import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getDatabase, ref, get } from "firebase/database";
import spinner from "../images/spinner.gif";
import "./Message.css";
import { pushMessage, checkUser } from "../utils/database";
import Cookies from "js-cookie";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Message() {
  const { userid } = useParams();
  const navigate = useNavigate();
  const [userExist, setUserExist] = useState(false);
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState({});
  const [userdata, setUserdata] = useState({});
  const [text, setText] = useState("");
  useEffect(() => {
    if (userid != "") {
      const accessToken = Cookies.get("accessToken");
      const accessTokenSecret = Cookies.get("accessTokenSecret");
      const accessProvider = Cookies.get("accessProvider");
      if (accessProvider == undefined) {
        Cookies.remove("accessToken", { path: "" });
        Cookies.remove("accessTokenSecret", { path: "" });
      }
      checkUser(accessProvider, accessToken, accessTokenSecret).then(
        (userData) => {
          if (userData) {
            setUserdata(userData);
          }
        }
      );
      const db = getDatabase();
      const usersRef = ref(db, "users/" + userid);
      get(usersRef)
        .then((snapshot) => {
          if (snapshot.exists()) {
            setUserData(snapshot.val());
            setUserExist(true);
            document.title = snapshot.val().username + " message page";
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, []);
  function handlePushMessage() {
    pushMessage(userData.uid, userdata.username, text)
      .then((result) => toast.success("Message sent!"))
      .catch((err) => {
        toast.error(err);
      });
  }
  if (loading)
    return (
      <div className="container">
        <div className="spinner">
          <img src={spinner} />
        </div>
      </div>
    );
  if (!userExist)
    return (
      <div className="background-color">
        <h1 className="not-found">User Not Found</h1>
      </div>
    );
  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
      />
      <div className="container">
        <div className="container-message">
          <div className="container-head">
            Send message to @{userData.username}!
          </div>
          <textarea
            onChange={(e) => {
              if (e.target.value.length > 64) {
                toast.error("Message cannot be more than 64 characters");
              } else {
                setText(e.target.value);
              }
            }}
            placeholder="Who is your crush??..."
            type="text"
            maxLength={64}
          />
          <button onClick={() => handlePushMessage()}>SEND</button>
        </div>
        <button className="button-back" onClick={() => navigate("/")}>
          Back To Home
        </button>
      </div>
    </>
  );
}

export default Message;
